import { render, staticRenderFns } from "./TermsContract.vue?vue&type=template&id=cb05c43c&scoped=true&"
import script from "./TermsContract.vue?vue&type=script&lang=js&"
export * from "./TermsContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb05c43c",
  null
  
)

export default component.exports